import cover from "@/assets/images/cover-dp.jpg";
import coverRecherche from "@/assets/images/cover-recherche.jpg";

export const productListHeaderProps = () => ({
  filters: {
    type: Array,
    required: false,
    default: () => []
  },
  childrenCategories: {
    type: Array,
    required: false,
    default: () => []
  },
  title: {
    type: String,
    required: false,
    default: "Froid"
  },
  ambianceUrl: {
    type: String,
    required: false,
    default: null
  },
  total: {
    type: Number,
    required: false,
    default: null
  },
  isTheme: {
    type: Boolean,
    required: false,
    default: false
  },
  isSearch: {
    type: Boolean,
    required: false,
    default: false
  },
  keyWord: {
    type: String,
    required: false,
    default: null
  },
  breadcrumbs: {
    type: Array,
    required: false,
    default: () => []
  },
  alcool: {
    type: Boolean,
    required: false,
    default: false
  },
  firstFilter: {
    type: String,
    required: false,
    default: ""
  },
  isPro: {
    type: Boolean,
    required: false,
    default: false
  }
})

export const useProductListHeader = (props) => {
  const mappedBreadcrumbs = computed(() => {
    return props.breadcrumbs.map((item) => {
      return {
        text: item.title,
        route: item.slug
      };
    });
  })
  const showBreadcrumbs = computed(() => {
    return mappedBreadcrumbs.value && mappedBreadcrumbs.value.length > 0 && !props.isSearch
  })

  const backgroundStyle = computed(() => {
    return props.isTheme ? { 'background-color': '#FFF' } : { 'background-image': `url(${props.ambianceUrl ? props.ambianceUrl : props.isSearch ? coverRecherche : cover})` }
  })
  return {
    mappedBreadcrumbs,
    showBreadcrumbs,
    backgroundStyle,
    cover
  }
}